import React from 'react';
import { Device } from '../../../hooks/useGetCurrentUserDevices';
import styled from 'styled-components';
import { deviceOnlineState } from '../../../services/device-utils-v2';

// Define the props for the DeviceStatusTag component
interface DeviceStatusTagProps {
  device: Device;
}

const StatusTag = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #4a4a4a;
  font-size: .75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: .75em;
  padding-right: .75em;
  white-space: nowrap;
`;

const OfflineStatusTag = styled(StatusTag)`
  color: #4A4A4A;
  background-color: #ec8d8d;
`;

const OnlineStatusTag = styled(StatusTag)`
  color: #4A4A4A;
  background-color: #93EC8D;
`;

const SleepingStatusTag = styled(StatusTag)`
  color: #4A4A4A;
  background-color: orange;
`;

// Functional component with TypeScript
export const DeviceStatusTag: React.FC<DeviceStatusTagProps> = ({ device }) => {
  if (device.state === 'suspended') {
    return <OfflineStatusTag>SUSPENDED</OfflineStatusTag>;
  }
  const onlineState = deviceOnlineState(device);
  switch (onlineState) {
    case 'online':
      return <OnlineStatusTag>ONLINE</OnlineStatusTag>;
    case 'sleeping':
      return <SleepingStatusTag>SLEEPING</SleepingStatusTag>;
    default:
      return <OfflineStatusTag>OFFLINE</OfflineStatusTag>;
  }
};
